// (function () {
//   const CUSTOMISER_IDS = ['9171', '6962', '7056', '2247']; // ← array, not ||
//   const THRESHOLD = 299;

//   function initForId(CUSTOMISER_ID) {

//     function getContainer() {
//       return document.querySelector('[data-customiserid="' + CUSTOMISER_ID + '"]');
//     }

//     function getPrice(container) {
//       const el = container.querySelector('.tw-text-main-price .money');
//       if (!el) return 0;
//       return parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
//     }

//     function getFreeGiftBlock(container) {
//       return [...container.querySelectorAll('.npc-selections-additional-item')]
//         .find(el =>
//           el.querySelector('.npc-selections-additional-title')
//             ?.textContent?.toUpperCase().includes('FREE GIFT')
//         );
//     }

//     function updateVisibility() {
//       const container = getContainer();
//       if (!container) return false;

//       const block = getFreeGiftBlock(container);
//       if (!block) return false;

//       const price = getPrice(container);

//       if (price >= THRESHOLD) {
//         block.style.setProperty('display',        'block',   'important');
//         block.style.setProperty('visibility',     'visible', 'important');
//         block.style.setProperty('opacity',        '1',       'important');
//         block.style.setProperty('height',         'auto',    'important');
//         block.style.setProperty('overflow',       'visible', 'important');
//         block.style.setProperty('pointer-events', 'auto',    'important');
//         block.setAttribute('data-free-gift', 'visible');
//       } else {
//         block.style.setProperty('display', 'none', 'important');
//         block.setAttribute('data-free-gift', 'hidden');
//       }

//       return true;
//     }

//     function pollUntilReady() {
//       let attempts = 0;
//       const interval = setInterval(() => {
//         attempts++;
//         if (updateVisibility() || attempts >= 60) clearInterval(interval);
//       }, 500);
//     }

//     function startObserver() {
//       let debounce = null;
//       let locked = false;

//       const observer = new MutationObserver(() => {
//         if (locked) return;
//         clearTimeout(debounce);
//         debounce = setTimeout(() => {
//           locked = true;
//           updateVisibility();
//           locked = false;
//         }, 150);
//       });

//       observer.observe(document.body, {
//         childList:     true,
//         subtree:       true,
//         characterData: true
//       });
//     }

//     pollUntilReady();
//     startObserver();
//   }

//   // ── Boot one independent instance per customiser ID ──────────────────────
//   function init() {
//     CUSTOMISER_IDS.forEach(id => initForId(id));
//   }

//   document.readyState === 'loading'
//     ? document.addEventListener('DOMContentLoaded', init)
//     : init();
// })();




(function () {
  const CUSTOMISER_IDS = ['9171', '6962', '7056', '2247'];
  const THRESHOLD = 299;

  function getContainer(id) {
    return document.querySelector('[data-customiserid="' + id + '"]');
  }

  function getPrice(container) {
    const el = container?.querySelector('.tw-text-main-price .money');
    if (!el) return 0;
    return parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
  }

  function getFreeGiftBlock(container) {
    return [...(container?.querySelectorAll('.npc-selections-additional-item') || [])]
      .find(el =>
        el.querySelector('.npc-selections-additional-title')
          ?.textContent?.toUpperCase().includes('FREE GIFT')
      );
  }

  function enforceLogic() {
    CUSTOMISER_IDS.forEach(id => {
      const container = getContainer(id);
      if (!container) return;

      const block = getFreeGiftBlock(container);
      if (!block) return;

      const price = getPrice(container);

      if (price >= THRESHOLD) {
        // ✅ SHOW
        block.style.setProperty('display', 'block', 'important');
        block.style.setProperty('visibility', 'visible', 'important');
        block.style.setProperty('opacity', '1', 'important');
        block.style.setProperty('height', 'auto', 'important');
        block.style.setProperty('pointer-events', 'auto', 'important');
      } else {
        // ❌ FORCE HIDE (even if user tries to show)
        block.style.setProperty('display', 'none', 'important');
        block.style.setProperty('visibility', 'hidden', 'important');
        block.style.setProperty('opacity', '0', 'important');
        block.style.setProperty('height', '0px', 'important');
        block.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }

  // 🔁 Run continuously (self-healing)
  setInterval(enforceLogic, 300);

})();